module.exports = __webpack_public_path__ + "static/media/zhuzhengting.72dfc071.png";